import * as actionTypes from './actionTypes';

const initialState = {
  tosCheckBoxState: { terms: null, custAgree: null, custVHDP: null, eppTCAgreement: null, billAgree: null },
  tosEnable: false,
  submitButtonFlag: false,
};

function expressTermsAndConditions(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_ETOS_CHECKBOX_STATE:
      return { ...state, tosCheckBoxState: action.response };

    case actionTypes.ENABLE_EXP_BUTTON:
      return { ...state, tosEnable: action.data };

    case actionTypes.SUBMIT_BUTTON_CLICK:
      return { ...state, submitButtonFlag: action.data };

    default:
      return state;
  }
}

export default expressTermsAndConditions;
